import { format, isValid, parse } from 'date-fns';

/** Props for the dashboard date-range calendar. ISO instants, calendar days. */
export type DateRangeCalendarProps = {
  from: string;
  to: string;
  onFromChange: (iso: string) => void;
  onToChange: (iso: string) => void;
  disabled?: boolean;
};

const DAY = /^(\d{4}-\d{2}-\d{2})/;

/** Calendar day of an ISO instant, read from the date prefix so the zone cannot shift it. */
export function isoToCalendarDate(iso: string): Date | undefined {
  const match = DAY.exec(iso);
  if (!match) return undefined;
  const date = parse(match[1], 'yyyy-MM-dd', new Date());
  return isValid(date) ? date : undefined;
}

/** Calendar day the person picked, stored as the same UTC day the text fields used. */
export function calendarDateToIso(date: Date, endOfDay: boolean): string {
  const day = format(date, 'yyyy-MM-dd');
  return endOfDay ? `${day}T23:59:59.999Z` : `${day}T00:00:00.000Z`;
}

/** Both ends, earlier day first. Undefined until the range is complete. */
export function commitCalendarRange(
  range: { from?: Date; to?: Date } | undefined,
): { from: string; to: string } | undefined {
  if (!range?.from || !range.to) return undefined;
  const [start, end] = range.from.getTime() <= range.to.getTime()
    ? [range.from, range.to]
    : [range.to, range.from];
  return {
    from: calendarDateToIso(start, false),
    to: calendarDateToIso(end, true),
  };
}
